export class GetPaymentHistoryRequest {
    KeywordSearches: string[];
    PageNumber: number;
    ItemsPerPage: number;
    StartDate: string;
    EndDate: string;
    StatusFilter: number;
    Sorting: number;
    memberIds: string[];
}
